/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RealEstateEligibilityDto } from './RealEstateEligibilityDto';
import {
    RealEstateEligibilityDtoFromJSON,
    RealEstateEligibilityDtoFromJSONTyped,
    RealEstateEligibilityDtoToJSON,
    RealEstateEligibilityDtoToJSONTyped,
} from './RealEstateEligibilityDto';

/**
 * 
 * @export
 * @interface EvaluateEligibilityResponseDto
 */
export interface EvaluateEligibilityResponseDto {
    /**
     * 
     * @type {Array<RealEstateEligibilityDto>}
     * @memberof EvaluateEligibilityResponseDto
     */
    realEstates?: Array<RealEstateEligibilityDto>;
}

/**
 * Check if a given object implements the EvaluateEligibilityResponseDto interface.
 */
export function instanceOfEvaluateEligibilityResponseDto(value: object): value is EvaluateEligibilityResponseDto {
    return true;
}

export function EvaluateEligibilityResponseDtoFromJSON(json: any): EvaluateEligibilityResponseDto {
    return EvaluateEligibilityResponseDtoFromJSONTyped(json, false);
}

export function EvaluateEligibilityResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluateEligibilityResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'realEstates': json['realEstates'] == null ? undefined : ((json['realEstates'] as Array<any>).map(RealEstateEligibilityDtoFromJSON)),
    };
}

export function EvaluateEligibilityResponseDtoToJSON(json: any): EvaluateEligibilityResponseDto {
    return EvaluateEligibilityResponseDtoToJSONTyped(json, false);
}

export function EvaluateEligibilityResponseDtoToJSONTyped(value?: EvaluateEligibilityResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realEstates': value['realEstates'] == null ? undefined : ((value['realEstates'] as Array<any>).map(RealEstateEligibilityDtoToJSON)),
    };
}

